import { filter, OperatorFunction } from 'rxjs';

export function filterFalsy<T>(): OperatorFunction<T, NonNullable<T>> {
  return filter((value: T): value is NonNullable<T> => !!value);
}
